export class CloneProfile {
  static readonly type = '[Contract.Profile] Clone Profile';
  constructor(public profileID: number, public copies: number = 1) {}
}

export class DeleteProfile {
  static readonly type = '[Contract.Profile] Delete Profile';
  constructor(public profileID: number) {}
}

export class RestoreProfile {
  static readonly type = '[Contract.Profile] Restore Profile';
  constructor(public profileID: number) {}
}

export class AddProfile {
  static readonly type = '[Contract.Profile] Add Profile';
  constructor(public profile: any, public articleID: number = null) {}
}

export class UpdateProfile {
  static readonly type = '[Contract.Profile] Update Profile';
  constructor(public profile: any) {}
}
